import { AppColorsT } from './appColors'
import { Theme, createDarkTheme, createLightTheme } from 'baseui';
import {
    createThemedStyled,
    createThemedWithStyle,
    createThemedUseStyletron    
} from 'baseui';
import {colors} from 'baseui/tokens'
import { AppSizesT } from './appSizes';

export type CustomThemeT = Theme & AppColorsT & AppSizesT;

const primitives = {};
const overrides = {};
const darkTheme = createDarkTheme(primitives, overrides);
const lightTheme = createLightTheme(primitives, overrides);

export const DarkTheme: CustomThemeT = {
    ...darkTheme,
    appColors: {
        aggregate: {
            on: darkTheme.colors.positive300,
            off: darkTheme.colors.contentSecondary,
            error: darkTheme.colors.backgroundNegative,
            man: darkTheme.colors.backgroundAccent,
            setpoint: darkTheme.colors.warning300,
            actualValue: darkTheme.colors.accent200,
            output: darkTheme.colors.notificationPositiveBackground
        },
        measurments: {
            temperature: colors.platinum400,//'#4A5B66',
            humidity: colors.blue100,//'#AFD8F2',
            airPressure: colors.teal300,//"#7894A6",
            pressure: colors.teal300,//"#81A0B3",
            airVolume: colors.teal300,
            energy: colors.orange600,
            brightness: darkTheme.colors.warning500,
            default: colors.platinum600
        },
        medium: {
            electricity: colors.yellow400,//"#B3A570",
            heat: colors.red600,
            cold: colors.platinum300,
            water: colors.blue600,
            gas: colors.yellow600,
            fuel: colors.brown600,
            default: colors.platinum800//'#B3A570'
        }
    },
    appSizes:{
        xSmallAppHeight: '110px',
        smallAppHeight: '220px',
        mediumAppHeight: '400px',
        largeAppHeight: '500px',
    }
}; 

export const LightTheme: CustomThemeT = {
    ...lightTheme,
    appColors: {
        aggregate: {
            on: lightTheme.colors.positive300,
            off: lightTheme.colors.contentSecondary,
            error: lightTheme.colors.backgroundNegative,
            man: lightTheme.colors.backgroundAccent,
            setpoint: darkTheme.colors.warning300,
            actualValue: darkTheme.colors.accent200,
            output: darkTheme.colors.notificationPositiveBackground
        },
        measurments: {
            temperature: colors.platinum400,//'#4A5B66',
            humidity: colors.blue100,//'#AFD8F2',
            airPressure: colors.teal300,//"#7894A6",
            pressure: colors.teal300,//"#81A0B3",
            airVolume: colors.teal300,
            energy: colors.orange600,
            brightness: darkTheme.colors.warning500,
            default: colors.platinum600
        },
        medium: {
            electricity: colors.yellow400,//"#B3A570",
            heat: colors.red600,
            cold: colors.platinum300,
            water: colors.blue600,
            gas: colors.yellow600,
            fuel: colors.brown600,
            default: colors.platinum800//'#B3A570'
        }
    },
    appSizes:{
        xSmallAppHeight: '110px',
        smallAppHeight: '220px',
        mediumAppHeight: '400px',
        largeAppHeight: '500px',
    }
};

export const themedStyled = createThemedStyled<CustomThemeT>();
export const themedWithStyle = createThemedWithStyle<CustomThemeT>();
export const themedUseStyletron  = createThemedUseStyletron<CustomThemeT>();
